import VerofreshRecord from './VerofreshRecord'
import Moment from 'moment'

class CustomerAssessmentTermRecord extends VerofreshRecord {
  /**
   * Return true if the term is archived, otherwise false
   * @returns {boolean}
   */
  get isArchived () {
    return this.archived != null
  }

  /**
   * Set whether the term is archived.
   * If state is true, will update 'archived' to current time.
   * if state is false, will set 'archived' to null.
   * @param state
   */
  set isArchived (state) {
    if (state) {
      this.archived = Moment().format()
    } else {
      this.archived = null
    }
  }
}

export default CustomerAssessmentTermRecord
